import { unitWord } from "../../goals/goalRules";
import { activityText } from "./goalItems";
import { memberName } from "./memberSelection";

/**
 * Toplu atama önizlemesi ve sonucunun metinleri (mobil previewText.ts ile
 * aynı). Sunucunun cevabı: { dryRun, added, updated, members, failed }.
 */

/**
 * Önizleme: "18 kişiye eklenecek · 6 kişide güncellenecek".
 * Sonuç: "18 eklendi · 6 güncellendi · 1 kişiye eklenemedi".
 * Sayılar üye sayısıdır; sıfır olan kısım yazılmaz.
 */
export function summaryText(result, phase, t) {
  const preview = phase === "preview";
  const parts = [];
  if (result.added > 0) parts.push(t(preview ? "bulk_will_add" : "bulk_added", { n: result.added }));
  if (result.updated > 0) parts.push(t(preview ? "bulk_will_update" : "bulk_updated", { n: result.updated }));
  if (!preview && (result.failed || []).length > 0) parts.push(t("bulk_failed_count", { n: result.failed.length }));
  return parts.length ? parts.join(" · ") : t("bulk_no_change");
}

/** Birimi değişecek hedefler; aynı hedef ve aynı değişim tek satırda. */
export function unitChangeRows(result) {
  const rows = new Map();
  for (const member of result.members || []) {
    for (const goal of member.goals || []) {
      if (!goal.unitChange) continue;
      const key = `${goal.label}::${goal.activity}::${goal.unitChange.from}::${goal.unitChange.to}`;
      const row = rows.get(key) ?? {
        key,
        label: goal.label,
        activity: goal.activity,
        from: goal.unitChange.from,
        to: goal.unitChange.to,
        names: [],
      };
      row.names.push(memberName(member));
      rows.set(key, row);
    }
  }
  return Array.from(rows.values());
}

/** "3 kişide Kur'an · okuma: sayfa → satır" */
export function unitChangeText(row, t) {
  const activity = activityText(row.activity, t).toLocaleLowerCase("tr-TR");
  return `${t("bulk_in_people", { n: row.names.length })} ${row.label} · ${activity}: ${unitWord(row.from, t)} → ${unitWord(row.to, t)}`;
}

/** Sunucu grupta olmayanın adını vermez; ad istemcinin üye listesinden bulunur. */
export function failedRows(result, members) {
  const byId = new Map((members || []).map((m) => [String(m.id), m]));
  return (result.failed || []).map((f) => {
    const local = byId.get(String(f.userId));
    return { userId: f.userId, name: local ? memberName(local) : (f.name ?? ""), reason: f.reason };
  });
}

const KNOWN_REASONS = {
  "Grupta değil": "bulk_reason_not_in_group",
  "Kullanıcı silinmiş": "bulk_reason_deleted",
  "Kullanıcı bulunamadı": "bulk_reason_not_found",
  "Hedefler kaydedilemedi": "bulk_reason_save_failed",
};

/** Sunucunun bilinen neden metinleri çevrilir; diğerleri olduğu gibi gösterilir. */
export function reasonText(reason, t) {
  return KNOWN_REASONS[reason] ? t(KNOWN_REASONS[reason]) : reason;
}

/** Üye başına kısa satır: "Kur'an · okuma eklenecek, Cevşen güncellenecek". */
export function memberChangeText(member, phase, t) {
  const preview = phase === "preview";
  return (member.goals || [])
    .map((g) => {
      const action =
        g.action === "add"
          ? t(preview ? "bulk_action_add" : "bulk_action_added")
          : t(preview ? "bulk_action_update" : "bulk_action_updated");
      return `${g.label} · ${activityText(g.activity, t).toLocaleLowerCase("tr-TR")} ${action}`;
    })
    .join(", ");
}
